import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { PageWrapper } from "../../components";
import { notificationAction } from "../../actions";
import "./embark.scss";
import { privateRoutes } from "../../Routes/routing";
import { getChildFeatureByName } from "../Snapshot/snapshotApi";
import { StorageService } from "../../api";
import SnapshotNavigation from "./Navigation/Navigation";
import { ConfirmDialog, LoadingMask } from "../../common";
import { embarkLogin, embarkAppLoginApi } from "./embarkApi";
import ManageFlows from "./views/Flows/ManageFlows";
import ManageIPros from "./views/ManageIPros/ManageIPros";
import MyWork from "./views/MyWork/MyWork";
import Dashboard from "./views/Dashboard/Dashboard";

class Snapshot extends Component {
  state = {
    UserFeatures: [],
    token: "",
    ExpenseCategories: [],
    Currencies: [],
    isLoading: true,
    UserId: -1,
    dialogMessage: "",
  };
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.onRouteChanged();
    }
  }

  onRouteChanged() {
    const firstUrl = this.state.UserFeatures.find((a) => a.Url);
    var queryString = window.location.href;
    queryString = queryString.toLowerCase().split("embark")[1];
    if (queryString == "") {
      if (firstUrl) {
        const isApp = window.location.hash.toLowerCase().indexOf("apps") > -1;
        this.props.history.push(
          (isApp ? "/apps" : "") + "/embark/" + firstUrl.Url
        );
      }
    }
  }
  componentDidMount() {
    getChildFeatureByName({ featureName: 'embark' })
      .then((res) => {
        this.setState({
          UserFeatures: res.items,
        });
        const { items } = res;
        const firstUrl = items.find((a) => a.Url);
        var queryString = window.location.href;
        queryString = queryString.toLowerCase().split("embark")[1];
        if (queryString == "") {
          if (firstUrl) {
            const isApp =
              window.location.hash.toLowerCase().indexOf("apps") > -1;
            this.props.history.push(
              (isApp ? "/apps" : "") + "/embark/" + firstUrl.Url
            );
          }
        }
      })
      .catch((err) => console.log("Err ", err));

    let { UserEmail } = this.props.User;
    let Email = UserEmail;
    if (!Email) {
      const User = StorageService.getUser();
      Email = User.Email;
    }
    this.setState({
      UserId: this.props.User.UserId,
    });
    embarkAppLoginApi(Email)
      .then((res) => {
        if (res.success) {
          embarkLogin(Email)
            .then((res) => {
              if (res.success) {
                const { access_token } = res.items;
                this.setState({
                  token: access_token,
                  isLoading: false,
                });
              }
            })
            .catch((err) => console.log(err));
        }
      })
      .catch((Err) => console.log("Error ", Err));
  }
  handleOkClick = () => {
    this.props.history.push(privateRoutes.dashboard.path);
  };
  render() {
    const { labels, isHelpActive, location } = this.props;
    const {
      UserFeatures,
      token,
      Currencies,
      dialogMessage,
      ExpenseCategories,
      isLoading,
      UserId,
      pendingtimesheet,
      Rejectedtimesheet,
      Rejectedexpense,
      Pendingexpense,
    } = this.state;
    const hashesList = [
      "#/apps/embark/",
      "#/embark/",
      "#/apps/embark",
      "#/embark",
    ];
    const currentViewHash =
      window.location.hash.toLowerCase().split("/")[1] == "apps"
        ? window.location.hash.toLocaleLowerCase().split("/")[3]
        : window.location.hash.toLocaleLowerCase().split("/")[2];
    return (
      <PageWrapper className={`snapshot-page`}>
        {isLoading && (
          <div id="loader-wrapper">
            <div test-data-id={"loader"} id="loader" />
          </div>
        )}
        <SnapshotNavigation
          disabled={`${isLoading ? "disabled" : ""}`}
          labels={labels}
          isHelpActive={isHelpActive}
          UserFeatures={UserFeatures}
        />
        {dialogMessage && (
          <ConfirmDialog testId="confirm-diloag">
            <ConfirmDialog.Message>{dialogMessage}</ConfirmDialog.Message>
            <ConfirmDialog.ActionButtons>
              <ConfirmDialog.Button
                className="dialog-btn"
                onClick={this.handleOkClick}
              >
                {"Ok"}
              </ConfirmDialog.Button>
            </ConfirmDialog.ActionButtons>
          </ConfirmDialog>
        )}
        {!isLoading && (
          <React.Fragment>
            {currentViewHash == "home" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <Dashboard
                  token={token}
                  Readyforapproval={pendingtimesheet}
                  Rejected={Rejectedtimesheet}
                  asOwnerCount={"12"}
                  Rejectedexpense={Rejectedexpense}
                  Pendingexpense={Pendingexpense}
                  UserFeatures={UserFeatures}
                />
              )}
            {currentViewHash == "mywork" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <MyWork
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                />
              )}
            {currentViewHash == "manageipros" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <ManageIPros
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                  UserId={UserId}
                  locationProp={location}
                />
              )}
            {currentViewHash == "manageflows" &&
              UserFeatures.findIndex(
                (a) =>
                  a.Url && a.Url.toLocaleLowerCase().trim() == currentViewHash
              ) > -1 && (
                <ManageFlows
                  token={token}
                  Currencies={Currencies}
                  ExpenseCategories={ExpenseCategories}
                  UserId={UserId}
                />
              )}
          </React.Fragment>
        )}
      </PageWrapper>
    );
  }
}
const mapStateToProps = ({ systemLabel, navigation, userInfo }) => {
  const { labels } = systemLabel;
  const { user } = userInfo;
  const User = user ? user : StorageService.getUser();
  const { isHelpActive } = navigation;
  return { labels, isHelpActive, User };
};
export default connect(
  mapStateToProps,
  { notificationAction }
)(Snapshot);
